module.exports = __webpack_public_path__ + "assets/5028e02c0aee23523f7c42c1a3c42e9d.mp3";